/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_CardInputs */

const en_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Card`)
};

const fr_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de mise à jour`)
};

const de_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierungskarte`)
};

const it_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna la scheda`)
};

const ru_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта обновления`)
};

const es_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta de actualización`)
};

const zh_cn2_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新卡`)
};

const ja_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カードを更新`)
};

const hi_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्ड अपडेट करें`)
};

const pt_pt2_update_card = /** @type {(inputs: Update_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão de atualização`)
};

/**
* | output |
* | --- |
* | "Update Card" |
*
* @param {Update_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_card = /** @type {((inputs?: Update_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_card(inputs)
	if (locale === "de") return de_update_card(inputs)
	if (locale === "it") return it_update_card(inputs)
	if (locale === "ru") return ru_update_card(inputs)
	if (locale === "es") return es_update_card(inputs)
	if (locale === "zh-CN") return zh_cn2_update_card(inputs)
	if (locale === "ja") return ja_update_card(inputs)
	if (locale === "hi") return hi_update_card(inputs)
	if (locale === "pt-PT") return pt_pt2_update_card(inputs)
	return en_update_card(inputs)
});